module.exports = __webpack_public_path__ + "static/mac-7c4035b7df6cfd1ec5023308386c90be.jpg";